import { pointsXChangeConfig } from './points-xchange';
import { pointsXChangeDesktopConfig } from './points-xchange-desktop';

export const allJourneyDetails: Record<string, unknown> = {
  pointsXChange:
    window.innerWidth < 768 ? pointsXChangeConfig : pointsXChangeDesktopConfig,
};
